import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import OAuthService from '../services/oauth.service';

@Injectable()
export class TokenSesionInterceptor implements HttpInterceptor {
  constructor(private router: Router, private user: OAuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = sessionStorage.getItem('data')
      ? this.user.getData().token
      : '';

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
        setParams: {
          userId: this.user.getData().userId,
          roleId: this.user.getData().roleId,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          sessionStorage.removeItem('data');
          this.router.navigate(['/login']);
        } else if (err.status === 403) {
          this.router.navigate(['admin/error/403']);
        }
        return throwError(() => err);
      })
    );
  }
}
